import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";

@Component({
  selector: 'app-scholarship',
  templateUrl: './scholarship.component.html',
  styleUrls: ['./scholarship.component.scss']
})
export class ScholarshipComponent {

  scholarshipForm: FormGroup;



  constructor(private fb: FormBuilder) {
    this.scholarshipForm = this.fb.group({
      fullName: [''],
      email: [''],
      country: [''],
      city: [''],
      mobile: [''],
      programmeType: [''],
      programmeDiscipline: [''],
      course: ['']
    });
  }

  onSubmit() {
    if (this.scholarshipForm.valid) {
      // Handle form submit logic here
    }
  }

}
